export function classNames(...classes: string[]): { className: string } {
    return { className: [...classes].filter((cn) => !!cn).join(" ") };
}
